





























































import Vue from 'vue'
import Component from "vue-class-component";
import {Getter, Action} from "vuex-class";
import {cloneDeep, isEqual} from "lodash";
import { CollapseTransition } from "vue2-transitions";
import {FormRowWings,SelectWings,DatePickerWings,ToggleWings,Collapse,SpoilerWings,TimeoutWings, InputWings} from 'wings-ui-components';
import {OriginatorItem} from "@/store/originators/types";
import { notifyError, notifyDelete, notifyConfirm } from '@/utils/notify-helper';
import {Ref, Watch} from "vue-property-decorator";
import { ActionLog } from '@/store/auth/types';
import { getTranslatedParams } from '@/utils/notify-utils';

Component.registerHooks([
  'beforeRouteLeave',
])

@Component({components: {
    FormRowWings,
    SelectWings,
    DatePickerWings,
    ToggleWings,
    Collapse,
    SpoilerWings,
    CollapseTransition,
    TimeoutWings,
    InputWings
}})
export default class Originator extends Vue {
  @Ref('validator') validator:any;
  @Getter("transportsForOriginatorsList") transportsForOriginatorsList: any;

  @Action("getTransports") actionGetTransports: any;
  @Action("getOriginatorItem") actionGetItem: any;
  @Action("saveOriginator") actionSave: any;
  @Action("deleteOriginator") actionDelete: any;
  @Action("actionLog") actionLog: any;

  defaultItem(): OriginatorItem {
    return {
      name: "",
      transport: "",
    };
  }

  private item = this.defaultItem();
  private itemSaved = this.defaultItem();
  logObject: ActionLog = {}

  get originatorRules() {
    let initialRule = 'required';
    if (this.item.transport) {
      switch (this.item.transport) {
        case 'SMS':
          return `${initialRule}|sms_originator`;
        case 'Call':
          return `${initialRule}|max:15|numeric`;
        case 'Email':
          return `${initialRule}|max:200|email|non_cyrillic`;
        case 'Viber':
        case 'WhatsApp':
          return `${initialRule}|viber_originator`;
        default:
          return initialRule;
      }
    }
    return initialRule;
  }

  async created() {
    try {
      if (this.$route.params.id) {
        const data = await this.actionGetItem(this.$route.params.id)
        this.item = Object.assign({},this.item, data);
        this.itemSaved = cloneDeep(Object.assign({},this.item, data));
      }
      this.actionGetTransports();
    } catch(error) {
      notifyError(error);
    }
  }

  back():void{
    this.$router.push('/sender');
  }

  onSaveItem():Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      if (!await this.validator.validate()) {
        notifyError(null, this.validator.errors)
        return
      }
      try {
        this.logObject = {
          actionPage: this.$route.meta.msgKey,
          action: "Creation",
          actionStatus: 'success',
          objectType: "Originator",
          objectName: this.item.name,
          addititionalInfo: getTranslatedParams({transport: this.item.transport})
        }
        await this.actionSave(this.item);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        resolve()
        this.back();
      } catch (error) {
        notifyError(error);
        await this.actionLog({...this.logObject, actionStatus: 'failed'})
        reject()
      }
    })
  }

  async onDeleteItem():Promise<void> {
    if (!await notifyDelete()) return
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Removal",
        actionStatus: 'success',
        objectType: "Originator",
        objectName: this.item.name,
        addititionalInfo: getTranslatedParams({transport: this.item.transport, id: this.item.id})
      }
      await this.actionDelete(this.item)
      await this.actionLog(this.logObject);
      this.itemSaved = this.item;
      this.back();
    } catch (error) {
      notifyError(error);
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
    }
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item,this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }

}
